export default __webpack_public_path__ + "static/bed-bath-beyond-9-b-3bda76aa87841c6e712e9247d68bcb3e.webp";